module.exports = __webpack_public_path__ + "img/img_2.8e349467.jpg";